<template>
  <div style="position: relative;">
    <div
      v-if="isReorganizingOptions"
      style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, 0.8); z-index: 10000; display: flex; align-items: center; justify-content: center;">
      <spinner-round
        :is-loading="isReorganizingOptions"
        :spinner-style="{ top: '0', position: 'static' }"
        v-if="isReorganizingOptions"></spinner-round>
    </div>

    <div v-if="sortedFirstOption && !isReorganizingOptions">
      <div class="is-border-top is-border--darken2 is-padding-xsmall">
        <span class="has-text-weight-bold is-size-6 is-padding-left-small">OPTION EN COURS</span>
      </div>
      <div class="columns is-flex is-marginless is-paddingless">
        <div
          class="column is-padding-small"
          style="background-color: #f2d054; flex: 0 0 60%; max-width: 60%;">
          <div class="columns is-marginless is-padding-xxsmall">
            <div class="column is-paddingless">
              <div class="is-flex is-align-items-center is-margin-bottom">
                <div class="rond-container">
                  <div class="rond"></div>
                  <div class="trait-vertical"></div>
                </div>
                <span
                  class="is-size-6"
                  style="white-space: nowrap;"> Date de l'option :
                  <span class="has-text-weight-semibold">{{ sortedFirstOption.start_date | prettyFullDatetime }}</span>
                </span>
              </div>
              <div class="is-flex is-align-items-center is-margin-bottom">
                <div class="rond-container">
                  <div class="rond"></div>
                </div>
                <span
                  class="is-size-6"
                  style="white-space: nowrap;"> Date d'expiration :
                  <span class="has-text-weight-semibold">{{ sortedFirstOption.end_date | prettyFullDatetime }}</span>
                </span>
              </div>
              <div
                class="is-flex is-align-items-center"
                style="position: relative; z-index: 10; white-space: nowrap; flex-wrap: nowrap;">
                <span
                  class="is-size-6 has-text-weight-semibold is-padding-left"
                  style="margin-right: 1rem; flex-shrink: 0;">Date de signature réservation :</span>
                <span
                  v-if="firstOption.signature_date"
                  class="has-text-weight-semibold is-size-6"
                  style="flex-shrink: 0;">{{ sortedFirstOption.signature_date | prettyFullDatetime }}</span>
                <span
                  v-if="!firstOption.signature_date"
                  class="is-size-6"
                  style="flex-shrink: 0;">
                  <date-picker
                    :style="{ ...textStyles, width: '200px' }"
                    :text="'Définir une date'"
                    :class="'is-underline is-italic has-cursor-pointer is-size-6'"
                    id="startDatePicker1"
                    :from-option="true"
                    :model="sortedFirstOption.previous_sign_date"
                    :style-version="4"
                    :clearable="false"
                    @input="updatePreviousDate($event, sortedFirstOption)"></date-picker>
                </span>
              </div>
            </div>
            <div class="column is-paddingless">
              <div class="is-padding-left-small">
                <div class="is-flex is-padding-bottom-xxsmall">
                  <span class="is-margin-bottom-xxsmall has-text-weight-semibold is-size-6">Société :
                    <span class="is-underline has-text-weight-normal"> {{ sortedFirstOption.account.name }}
                    </span>
                  </span>
                </div>
                <div class="is-flex is-padding-bottom-xxsmall">
                  <span class="is-margin-bottom-xxsmall has-text-weight-semibold is-size-6">Vendeur / Référent :
                    <span class="is-underline has-text-weight-normal">
                      <router-link
                        :to="{name: 'UserVue', params: {id: firstOption.user.pk}}">
                        {{ sortedFirstOption.user.last_name }} {{ sortedFirstOption.user.first_name }}
                      </router-link>
                    </span>
                  </span>
                </div>
                <div class="is-flex">
                  <span class="has-text-weight-semibold is-size-6">Contact déclaré :
                    <span
                      v-if="firstOption.contact.nature === 'corporation'">
                      <router-link
                        v-if="firstOption.contact.account.pk === currentUser.account.pk || (firstOption.contact.shared && firstOption.account.pk === currentUser.account.pk)"
                        :to="{name: 'ContactVue', params: {id: firstOption.contact.pk}}"
                        class="is-size-6 has-text-weight-normal">
                        {{ sortedFirstOption.contact.corporation_name }} ({{ sortedFirstOption.contact.last_name }} {{ sortedFirstOption.contact.first_name }})
                      </router-link>
                      <span
                        class="is-size-6 has-text-weight-normal"
                        v-else>
                        {{ sortedFirstOption.contact.corporation_name }} ({{ sortedFirstOption.contact.last_name }} {{ sortedFirstOption.contact.first_name }})
                      </span>
                    </span>
                    <span
                      v-else>
                      <router-link
                        v-if="firstOption.contact.account.pk == currentUser.account.pk || (firstOption.contact.shared && firstOption.account.pk == currentUser.account.pk)"
                        :to="{name: 'ContactVue', params: {id: firstOption.contact.pk}}"
                        class="is-size-6 has-text-weight-normal">
                        {{ sortedFirstOption.contact.last_name }} {{ sortedFirstOption.contact.first_name }}
                      </router-link>
                      <span
                        class="is-size-6 has-text-weight-normal"
                        v-else>
                        {{ sortedFirstOption.contact.last_name }} {{ sortedFirstOption.contact.first_name }}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="column is-marginless is-paddingless"
          style="display: flex; flex-direction: column;  flex: 0 0 40%; max-width: 40%;">
          <div style="display: flex; flex: 1;">
            <div
              class="is-border-right is-border-top is-border--darken1"
              style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 0.5rem; padding: 0.5rem;">
              <template v-if="isOptionReservationPending && !(isAdmin && isPromoteur)">
                <a
                  @click.prevent.stop="optionButtonList[4].action(sortedFirstOption.pk, sortedFirstOption)"
                  class="no-style-button">
                  <span
                    v-if="optionButtonList[4].icon"
                    class="icon">
                    <i
                      class="fas"
                      :class="optionButtonList[4].icon">
                    </i>
                  </span>
                  <span>{{ optionButtonList[4].text }}</span>
                </a>
              </template>
              <template v-else>
                <a
                  @click.prevent.stop="optionButtonList[0].action(sortedFirstOption.pk, sortedFirstOption)"
                  class="no-style-button">
                  <span
                    v-if="optionButtonList[0].icon"
                    class="icon">
                    <i
                      class="fas"
                      :class="optionButtonList[0].icon">
                    </i>
                  </span>
                  <span>{{ optionButtonList[0].text }}</span>
                </a>
              </template>
            </div>
            <div
              class="is-border-top is-border--darken1"
              style="flex: 1; display: flex; justify-content: center; align-items: center; padding: 0.5rem;">
              <a
                @click.prevent.stop="optionButtonList[3].action(sortedFirstOption.pk, sortedFirstOption)"
                class="no-style-button">
                <span
                  v-if="optionButtonList[3].icon"
                  class="icon">
                  <i
                    class="fas"
                    :class="optionButtonList[3].icon">
                  </i>
                </span>
                <span>{{ optionButtonList[3].text }}</span>
              </a>
            </div>
          </div>
          <div
            class="has-background-primary"
            style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 0.5rem; padding: 0.5rem;">
            <a
              v-if="isOptionReservationPending && !(isAdmin && isPromoteur)"
              @click.prevent.stop="optionButtonList[5].action(firstOption.pk, firstOption)"
              class="no-style-button">
              <span
                v-if="optionButtonList[5].icon"
                class="icon">
                <i
                  class="fas"
                  :class="optionButtonList[5].icon">
                </i>
              </span>
              <span>{{ optionButtonList[5].text }}</span>
            </a>
            <template v-else>
              <a
                v-if="optionButtonList[1].display(sortedFirstOption)"
                @click.prevent.stop="optionButtonList[1].action(sortedFirstOption.pk, sortedFirstOption)"
                class="no-style-button">
                <span
                  v-if="optionButtonList[1].icon"
                  class="icon">
                  <i
                    class="fas"
                    :class="optionButtonList[1].icon">
                  </i>
                </span>
                <span class="has-text-white">{{ optionButtonList[1].text }}</span>
              </a>
              <a
                v-if="optionButtonList[2].display(sortedFirstOption)"
                @click.prevent.stop="optionButtonList[2].action(sortedFirstOption.pk, sortedFirstOption)"
                class="no-style-button">
                <span
                  v-if="optionButtonList[2].icon"
                  class="icon">
                  <i
                    class="fas"
                    :class="optionButtonList[2].icon">
                  </i>
                </span>
                <span class="has-text-white">{{ optionButtonList[2].text }}</span>
              </a>
            </template>
          </div>
        </div>
      </div>
      <div
        class="is-padding-xsmall has-background-white-bis"
        v-if="isPromoteur">
        <div v-if="sortedFirstOption.comment || openedFirstComment">
          <div class="row-width-actions-bar columns is-gapless is-marginless">
            <div class="column is-self-centered is-padding-top-xxsmall is-padding-bottom-xxsmall has-background-white-bis">
              <span class="title is-6">
                <span class="is-uppercase is-margin-right-xsmall">{{ 'Commentaire :' }}</span>
              </span>
            </div>
          </div>
          <div
            v-if="openedFirstComment"
            class="is-border-top columns is-gapless">
            <div class="column">
              <wysiwyg-editor
                :light="true"
                :tooltip-top="true"
                :model="sortedFirstOption.comment"
                @change="val => sortedFirstOption.comment = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button
                  @click="sortedFirstOption.updated_on = moment().format(); patchOptionMixins(sortedFirstOption); baseFirstComment = null; openedFirstComment = null"
                  type="button"
                  class="button"
                  :class="[(baseFirstComment !== firstOption.comment) ? 'is-success' : 'is-info']"
                  :disabled="!firstOption.comment || (baseFirstComment === firstOption.comment) || loadLotComment">
                  <span class="icon is-small">
                    <i
                      v-if="loadLotComment"
                      class="fas fa-spinner fa-spin"></i>
                    <i
                      v-else
                      class="fal fa-save"></i>
                  </span>
                </button>
              </div>
              <div class="">
                <button
                  type="button"
                  :class="'actionsOnRow-btn--hoverIsDanger'"
                  @click="openedFirstComment = null; firstOption.comment = baseFirstComment; baseFirstComment = null">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
          <div
            v-else
            @click="openWysiwygFirstOption()"
            class="vadDiscussion is-border-top"
            style="cursor: pointer;">
            <div
              class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div
                class="content"
                v-html="sortedFirstOption.comment"></div>
            </div>
          </div>
          <div class="is-flex-between is-margin-top-xxsmall has-background-white-bis">
            <div>
              <span
                v-if="firstOption.updated_on !== null"
                class="is-size-6 has-text-weight-semibold is-margin-right-small">Date mise à jour option :
                <span class="has-text-weight-normal">{{ sortedFirstOption.updated_on | prettyFullDatetime }}</span></span>
            </div>
            <div>
              <span
                @click="openWysiwygFirstOption()"
                v-if="isPromoteur && openedFirstComment === null"
                class="is-size-6 is-underline is-margin-right-small has-cursor-pointer"><i>Modifier</i></span>
              <span
                @click="deleteFirstComment()"
                v-if="isPromoteur && openedFirstComment === null"
                class="is-size-6 is-underline has-cursor-pointer"><i>Supprimer</i></span>
            </div>
          </div>
        </div>
        <a
          v-else
          @click="openWysiwygFirstOption()"
          style="font-size: 12px"
          class="is-underline is-italic is-padding-left-xlarge">Ajouter commentaire
        </a>
      </div>
    </div>
    <div
      class="notification is-pre_reserved is-radiusless is-bordered is-margin-bottom-large is-paddingless"
      v-if="reservation && reservationOkStatus && !(isAdmin && isPromoteur) && !reservation.signature_date">
      <div class="is-padding">
        <div class="columns is-variable is-1">
          <span class="is-size-7 is-uppercase">
            <b>Vous disposez d’une pré-réservation sur ce lot.</b><br />
            Dans la cadre d’une signature manuscrite, Merci également de bien vouloir nous adresser par voie postale les originaux des contrats
          </span>
        </div>
      </div>
      <div class="level has-background-white is-padding-left">
        <div class="level-left">
          <div class="field is-grouped">
            <display-button-list
              class="control"
              :buttons="[optionButtonList[4]]"
              :data="reservation"
              :classes="'is-radiusless is-small is-white is-minH50p'"></display-button-list>
          </div>
        </div>
        <div class="level-right w50">
          <div class="field is-grouped w100">
            <display-button-list
              class="control is-expanded"
              :buttons="[optionButtonList[6]]"
              :data="reservation"
              classes="is-dark is-radiusless is-small is-minH50p is-fullwidth"></display-button-list>
          </div>
        </div>
      </div>
    </div>

    <div
      class="notification is-pre_reserved is-radiusless is-bordered is-margin-bottom-large is-paddingless"
      v-else-if="reservation && reservationOkStatus && isAdmin && isPromoteur && !reservation.signature_date">
      <div class="is-padding">
        <div class="columns is-variable is-1">
          <span class="">
            <b class="is-uppercase is-size-7">Lot pré-réservé : En attente du contrat de réservation.</b>&nbsp;<router-link
              class="is-size-6"
              :to="{name: 'AdvInfos', params: { id: reservation.pk }}">Consulter ADV</router-link>
          </span>
        </div>
      </div>
    </div>

    <div
      class="notification is-radiusless is-bordered is-margin-bottom-large is-paddingless"
      :class="'is-' + reservation.status"
      v-else-if="reservation && reservationOkStatus">
      <div class="is-padding">
        <div class="columns is-variable is-1">
          <div
            class="column columns is-gapless is-column is-space-between"
            v-if="reservation.account && reservation.account.pk !== currentUser.account.pk">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Société
            </div>
            <span class="is-size-5">
              {{ reservation.account.name }}
            </span>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-if="reservation.user && reservation.account.pk === currentUser.account.pk">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Vendeur
            </div>
            <router-link
              :to="{name: 'UserVue', params: {id: reservation.user.pk}}"
              class="is-size-5">
              {{ reservation.user.last_name }} {{ reservation.user.first_name }}
            </router-link>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-if="reservation.buyers_data && reservation.buyers_data[0] && reservation.buyers_data[0].nature === 'corporation'">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Acquéreur
            </div>
            <span
              class="is-size-5"
              v-if="reservation.buyers_data[0].account.pk !== currentUser.account.pk">
              {{ reservation.buyers_data[0].corporation_name }} ({{ reservation.buyers_data[0].last_name }} {{ reservation.buyers_data[0].first_name }})
            </span>
            <router-link
              v-else
              :to="{name: 'ContactVue', params: {id: reservation.buyers_data[0].pk}}"
              class="is-size-5">
              {{ reservation.buyers_data[0].corporation_name }} ({{ reservation.buyers_data[0].last_name }} {{ reservation.buyers_data[0].first_name }})
            </router-link>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-else-if="reservation.buyers_data && reservation.buyers_data[0]">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Acquéreur
            </div>
            <span
              class="is-size-5"
              v-if="reservation.buyers_data[0].account.pk !== currentUser.account.pk">
              {{ reservation.buyers_data[0].last_name }} {{ reservation.buyers_data[0].first_name }}
            </span>
            <router-link
              v-else
              :to="{name: 'ContactVue', params: {id: reservation.buyers_data[0].pk}}"
              class="is-size-5">
              {{ reservation.buyers_data[0].last_name }} {{ reservation.buyers_data[0].first_name }}
            </router-link>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-if="reservation.sale_date">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Date de vente
            </div>
            <span class="is-size-5">
              {{ reservation.sale_date | prettyFullDatetime }}
            </span>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-else-if="reservation.signature_date">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Date de passage en réservation
            </div>
            <span class="is-size-5">
              {{ reservation.signature_date | prettyFullDatetime }}
            </span>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-else-if="reservation.pre_reservation_date">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Date de passage en pré réservation
            </div>
            <span class="is-size-5">
              {{ reservation.pre_reservation_date | prettyFullDatetime }}
            </span>
          </div>
          <div
            class="column columns is-gapless is-column is-space-between"
            v-if="reservation.sale_price_ttc">
            <div class="is-size-6 is-margin-bottom-xsmall">
              Prix de vente
            </div>
            <div class="is-size-5">
              {{ reservation.sale_price_ttc | prettyPrice }} €
            </div>
          </div>
          <div class="column is-narrow is-self-centered has-text-right">
            <!--<display-button-list
              :forceDropDown="true"
              :buttons="optionButtonList"
              :data="reservation"
              :canDropDown="!loadingOptionAction"
              :icon-class="loadingOptionAction ? 'fa-spinner fa-spin' : 'fa-ellipsis-v'"
              classes="is-outlined is-circle is-grey-dark"
            ></display-button-list>-->

            <!-- <div class="field is-grouped is-grouped-multiline">
              <template v-for="(optButton, i) in optionButtonList">
                <display-button-list :key="'optBtnStatusOk' + i"
                  class="control"
                  :buttons="[optButton]"
                  :data="reservation"
                  :classes="'is-white is-small'"
                ></display-button-list>
              </template>
            </div> -->
          </div>
        </div>
      </div>
      <div class="level has-background-white is-padding-left">
        <div class="level-left">
          <div class="field is-grouped">
            <display-button-list
              class="control"
              :buttons="[optionButtonList[4]]"
              :data="reservation"
              :classes="'is-radiusless is-small is-white is-minH50p'"></display-button-list>
          </div>
        </div>
        <div class="level-right w50">
          <div class="field is-grouped w100">
            <display-button-list
              class="control is-expanded"
              :buttons="[optionButtonList[6]]"
              :data="reservation"
              classes="is-dark is-radiusless is-small is-minH50p is-fullwidth"></display-button-list>
          </div>
        </div>
      </div>
    </div>

    <div v-if="waitingList && waitingList.length > 0 && !isReorganizingOptions">
      <div class="is-padding-xsmall is-flex is-flex-between is-align-items-center">
        <span class="has-text-weight-bold is-size-6 is-padding-left-small">OPTION(S) EN LISTE D'ATTENTE</span>
      </div>
    </div>
    <div
      v-if="waitingList && waitingList.length > 0 && !isReorganizingOptions"
      class="is-radiusless is-margin-bottom-large is-warning is-paddingless">
      <div
        v-for="(waiting, i) in sortedWaitingList"
        :key="waiting.pk">
        <div class="columns is-flex is-marginless">
          <div
            class="column has-background-warning is-padding-small is-flex"
            style="flex: 0 0 65%; max-width: 65%;">
            <div class="is-padding-top-xsmall is-margin-right-xlarge">
              <div class="is-padding-left is-padding-bottom-xsmall">
                <span
                  class="is-size-6"
                  style="white-space: nowrap;"> Date de l'option :
                  <span class="has-text-weight-semibold">{{ waiting.start_date | prettyFullDatetime }}</span>
                </span>
              </div>
              <div
                class="is-flex is-align-items-center"
                style="position: relative; z-index: 10; white-space: nowrap; flex-wrap: nowrap;">
                <span
                  class="is-size-6 has-text-weight-semibold is-padding-left"
                  style="margin-right: 1rem; flex-shrink: 0;">Date de signature réservation :</span>
                <span
                  v-if="waiting.signature_date"
                  class="has-text-weight-semibold is-size-6"
                  style="flex-shrink: 0;">{{ waiting.signature_date | prettyFullDatetime }}</span>
                <span
                  v-if="!waiting.signature_date"
                  class="is-size-6"
                  style="flex-shrink: 0;">
                  <date-picker
                    :style="{ ...textStyles, width: '100px' }"
                    :text="'Définir une date'"
                    :class="'is-underline is-italic has-cursor-pointer is-size-6'"
                    id="startDatePicker1"
                    :from-option="true"
                    :model="waiting.previous_sign_date"
                    :style-version="4"
                    :clearable="false"
                    @input="updatePreviousDate($event, waiting)"></date-picker>
                </span>
              </div>
            </div>
            <div
              class="column is-paddingless"
              style="flex: 0 0 35%; max-width: 35%;">
              <div class="is-padding-left-xsmall">
                <div class="is-flex is-padding-bottom-xxsmall">
                  <span class="is-margin-bottom-xxsmall has-text-weight-semibold is-size-6">Société :
                    <span class="is-underline has-text-weight-normal"> {{ waiting.account.name }}
                    </span>
                  </span>
                </div>
                <div class="is-flex is-padding-bottom-xxsmall">
                  <span class="is-margin-bottom-xxsmall has-text-weight-semibold is-size-6">Vendeur / Référent :
                    <span class="is-underline has-text-weight-normal">
                      <router-link
                        :to="{name: 'UserVue', params: {id: waiting.user.pk}}">
                        {{ waiting.user.last_name }} {{ waiting.user.first_name }}
                      </router-link>
                    </span>
                  </span>
                </div>
                <div class="is-flex">
                  <span class="has-text-weight-semibold is-size-6">Contact déclaré :
                    <span
                      v-if="waiting.contact.nature === 'corporation'">
                      <router-link
                        v-if="waiting.contact.account.pk === currentUser.account.pk || (waiting.contact.shared && waiting.account.pk === currentUser.account.pk)"
                        :to="{name: 'ContactVue', params: {id: waiting.contact.pk}}"
                        class="is-size-6 has-text-weight-normal">
                        {{ waiting.contact.corporation_name }} ({{ waiting.contact.last_name }} {{ waiting.contact.first_name }})
                      </router-link>
                      <span
                        class="is-size-6 has-text-weight-normal"
                        v-else>
                        {{ waiting.contact.corporation_name }} ({{ waiting.contact.last_name }} {{ waiting.contact.first_name }})
                      </span>
                    </span>
                    <span
                      v-else>
                      <router-link
                        v-if="waiting.contact.account.pk == currentUser.account.pk || (waiting.contact.shared && waiting.account.pk == currentUser.account.pk)"
                        :to="{name: 'ContactVue', params: {id: waiting.contact.pk}}"
                        class="is-size-6 has-text-weight-normal">
                        {{ waiting.contact.last_name }} {{ waiting.contact.first_name }}
                      </router-link>
                      <span
                        class="is-size-6 has-text-weight-normal"
                        v-else>
                        {{ waiting.contact.last_name }} {{ waiting.contact.first_name }}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column has-background-white is-border is-border--darken2 is-marginless is-paddingless is-flex"
            style="flex: 0 0 35%; max-width: 35%;">
            <div
              class="is-border-right is-border--darken2 is-fullHeight has-cursor-pointer"
              style="max-width: 102px; min-height: 100%; flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;"
              @click.prevent.stop="optionButtonList[3].action(waiting.pk, waiting)">
              <i class="fas fa-stop-circle"></i>
            </div>
            <div
              class="multiselect-wrapper"
              style="min-height: 100%; flex: 1; display: flex; position: relative; z-index: 1001;">
              <div
                v-if="!getMultiselectState(waiting.pk).isOpen"
                @click="toggleMultiselect(waiting.pk)"
                class="multiselect-trigger"
                style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 1rem; cursor: pointer;">
                <span class="is-size-6 has-text-weight-normal is-margin-left-small">
                  {{ getMultiselectState(waiting.pk).selectedRang }}
                </span>
                <span class="icon is-margin-right-small">
                  <i class="fas fa-chevron-down"></i>
                </span>
              </div>
              <div
                v-else
                class="multiselect-dropdown is-border is-border--darken3"
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: #e3e2e2; border: 1px solid #dbdbdb; z-index: 1002; box-shadow: 0 2px 8px rgba(0,0,0,0.1); display: flex; flex-direction: column; overflow-y: auto; max-height: 100%;">
                <div
                  v-for="rang in rangOptions"
                  :key="rang"
                  @click="selectRang(waiting.pk, rang)"
                  @mouseenter="hoveredRang = rang"
                  @mouseleave="hoveredRang = null"
                  style="padding: 0.75rem 1rem; display: flex; cursor: pointer; position: relative;">
                  <span
                    v-if="hoveredRang === rang"
                    class="icon"
                    style="position: absolute; left: 0.5rem; color:#4a4a4a">
                    <i class="fas fa-check"></i>
                  </span>
                  <span class="is-size-6 is-margin-left">{{ rang }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has-background-white-bis is-padding-xsmall "
          v-if="isPromoteur">
          <div v-if="openedComment === i || waiting.comment">
            <div class="row-width-actions-bar columns is-gapless is-marginless">
              <div class="column is-self-centered is-padding-top-xxsmall is-padding-bottom-xxsmall has-background-white-bis">
                <span class="title is-6">
                  <span class="is-uppercase is-margin-right-xsmall">{{ 'Commentaire :' }}</span>
                </span>
              </div>
            </div>
            <div
              v-if="openedComment === i"
              class="is-border-top columns is-gapless">
              <div class="column">
                <wysiwyg-editor
                  :light="true"
                  :tooltip-top="true"
                  :model="waiting.comment"
                  @change="val => waiting.comment = val"
                  class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                </wysiwyg-editor>
              </div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div>
                  <button
                    @click="waiting.updated_on = moment().format(); patchOptionMixins(waiting); baseLotComment = null; openedComment = null"
                    type="button"
                    class="button"
                    :class="[(baseLotComment !== waiting.comment) ? 'is-success' : 'is-info']"
                    :disabled="!waiting.comment || (baseLotComment === waiting.comment) || loadLotComment">
                    <span class="icon is-small">
                      <i
                        v-if="loadLotComment"
                        class="fas fa-spinner fa-spin"></i>
                      <i
                        v-else
                        class="fal fa-save"></i>
                    </span>
                  </button>
                </div>
                <div class="">
                  <button
                    type="button"
                    :class="'actionsOnRow-btn--hoverIsDanger'"
                    @click="openedComment = null; waiting.comment = baseLotComment; baseLotComment = null">
                    <span class="icon is-small"><i class="fal fa-times"></i></span>
                  </button>
                </div>
              </div>
            </div>
            <div
              v-else
              @click="openWysiwygWaitingList(i)"
              class="vadDiscussion is-border-top"
              style="cursor: pointer;">
              <div
                class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                <div
                  class="content"
                  v-html="waiting.comment"></div>
              </div>
            </div>
            <div class="is-flex-between is-margin-top-xxsmall has-background-white-bis">
              <div>
                <span
                  v-if="waiting.updated_on !== null"
                  class="is-size-6 has-text-weight-semibold is-margin-right-small">Date mise à jour option :
                  <span class="has-text-weight-normal">{{ waiting.updated_on | prettyDatetime }}</span></span>
              </div>
              <div>
                <span
                  @click="openWysiwygWaitingList(i)"
                  v-if="isPromoteur && openedFirstComment === null"
                  class="is-size-6 is-underline is-margin-right-small has-cursor-pointer"><i>Modifier</i></span>
                <span
                  @click="deleteWaitingComment(i)"
                  v-if="isPromoteur && openedFirstComment === null"
                  class="is-size-6 is-underline has-cursor-pointer"><i>Supprimer</i></span>
              </div>
            </div>
          </div>
          <a
            v-else
            @click="openWysiwygWaitingList(i)"
            style="font-size: 12px"
            class="is-underline is-italic is-padding-left-xlarge">Ajouter commentaire
          </a>
        </div>
      </div>
      <div
        v-if="hasPendingChanges"
        class="columns is-flex is-marginless">
        <div
          class="column"
          style="flex: 0 0 50%; max-width: 50%;"></div>
        <div
          class="column has-background-white is-border--darken2 is-marginless is-paddingless"
          style="flex: 0 0 50%; max-width: 50%; display: flex; align-items: center; justify-content: center; padding: 1rem;">
          <button
            @click="cancelRangChanges"
            class="button is-light is-small is-padding-large"
            :disabled="isReorganizingOptions"
            style="flex: 1;">
            <span>ANNULER</span>
          </button>
          <button
            @click="applyRangChanges"
            class="button is-success is-small is-padding-large"
            :disabled="isReorganizingOptions"
            style="flex: 1;">
            <span>VALIDER</span>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="displayCanceled && (canceledList && canceledList.length > 0)"
      class="notification is-radiusless is-margin-bottom-xsmall is-warning is-paddingless has-background-white is-border-top">
      <div
        class="is-padding-right-small is-padding-left-small is-padding-top-xsmall columns is-gapless is-marginless">
        <div class="column is-8 is-paddingless">
          <span class="is-size-6 is-uppercase has-text-black has-text-weight-medium">Option(s) annulée(s) par le passage en réservation</span>
        </div>
      </div>
    </div>
    <template v-if="displayCanceled">
      <div
        v-for="(canceled, i) in canceledList"
        :key="canceled.pk"
        :class="{'is-border-top is-border': i > 0}">
        <div
          :class="{
            'has-background-white-ter': !canceled.has_reservation_field,
            'has-background-primary': canceled.has_reservation_field,
            'has-text-white': canceled.has_reservation_field,
            'is-padding-right-xsmall': true,
            'is-padding-left-xsmall': true
          }">
          <div class="columns is-gapless is-multiline is-vcentered">
            <div
              :class="{
                'column': true,
                'is-padding-small': true,
                'is-3': true
              }">
              <span
                :class="{
                  'is-size-6': true,
                  'has-text-black': !canceled.has_reservation_field,
                  'has-text-white': canceled.has_reservation_field,
                  'has-text-weight-medium': true
                }">
                Date de l'option :
              </span>
              <span class="is-size-7">
                {{ canceled.start_date | prettyFullDatetime }}
              </span>
            </div>
            <div
              class="column is-3 is-padding-small"
              v-if="canceled.account.pk !== currentUser.account.pk">
              <span
                :class="{
                  'is-size-6': true,
                  'has-text-black': !canceled.has_reservation_field,
                  'has-text-white': canceled.has_reservation_field,
                  'is-margin-bottom-xsmall': true,
                  'has-text-weight-medium': true
                }">
                Société:
              </span>
              <span class="is-size-7">{{ canceled.account.name }}</span>
            </div>
            <div
              class="column is-3 is-padding-small"
              v-if="canceled.user && canceled.account.pk === currentUser.account.pk">
              <span
                :class="{
                  'is-size-6': true,
                  'has-text-black': !canceled.has_reservation_field,
                  'has-text-white': canceled.has_reservation_field,
                  'is-margin-bottom-xsmall': true,
                  'has-text-weight-medium': true
                }">
                Vendeur :
              </span>
              <router-link
                :to="{name: 'UserVue', params: {id: canceled.user.pk}}"
                :class="{
                  'is-size-7': true,
                  'is-underline': true,
                  'has-text-black': !canceled.has_reservation_field,
                  'has-text-white': canceled.has_reservation_field,
                  'is-underline': true,
                }">
                {{ canceled.user.last_name }} {{ canceled.user.first_name }}
              </router-link>
            </div>
            <div
              class="column is-3 is-padding-small"
              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
              :title="canceled.contact.nature === 'corporation' ? canceled.contact.corporation_name : canceled.contact.last_name + ' ' + canceled.contact.first_name"
              v-if="canceled.contact">
              <span
                :class="{
                  'is-size-6': true,
                  'has-text-black': !canceled.has_reservation_field,
                  'has-text-white': canceled.has_reservation_field,
                  'is-margin-bottom-xsmall': true,
                  'has-text-weight-medium': true,
                }">
                Contact :
              </span>
              <span
                v-if="canceled.contact.nature === 'corporation'">
                <span
                  :class="{
                    'is-size-7': true,
                    'has-text-black': !canceled.has_reservation_field,
                    'has-text-white': canceled.has_reservation_field }"
                  v-if="canceled.contact.account.pk !== currentUser.account.pk">
                  {{ canceled.contact.corporation_name }} ({{ canceled.contact.last_name }} {{ canceled.contact.first_name }})
                </span>
                <router-link
                  v-else
                  :to="{name: 'ContactVue', params: {id: canceled.contact.pk}}"
                  :class="{
                    'is-size-7': true,
                    'has-text-black': !canceled.has_reservation_field,
                    'has-text-white': canceled.has_reservation_field}">
                  {{ canceled.contact.corporation_name }} ({{ canceled.contact.last_name }} {{ canceled.contact.first_name }})
                </router-link>
              </span>
              <span
                v-else>
                <span
                  :class="{
                    'is-size-7': true,
                    'has-text-black': !canceled.has_reservation_field,
                    'has-text-white': canceled.has_reservation_field}"
                  v-if="canceled.contact.account.pk !== currentUser.account.pk">
                  {{ canceled.contact.last_name }} {{ canceled.contact.first_name }}
                </span>
                <router-link
                  v-else
                  :to="{name: 'ContactVue', params: {id: canceled.contact.pk}}"
                  :class="{
                    'is-size-7': true,
                    'has-text-black': !canceled.has_reservation_field,
                    'has-text-white': canceled.has_reservation_field}">
                  {{ canceled.contact.last_name }} {{ canceled.contact.first_name }}
                </router-link>
              </span>
            </div>
            <div
              v-if="!canceled.has_reservation_field"
              class="column is-1"></div>
            <div
              v-if="canceled.has_reservation_field"
              class="column is-padding-small">
              <span class="is-size-7 has-text-weight-medium is-underline">Réservation annulée le </span>
              <span class="is-size-7 has-text-weight-medium is-underline">{{ canceled.updated_on | prettyDate }}</span>
            </div>
            <div
              v-if="!canceled.has_reservation_field"
              class="column is-2 is-padding-left-small is-padding-right-small">
              <a
                @click="restoreOptionsCanceled(canceled.pk)"
                class="button is-small is-light has-background-white is-border is-transform-none is-fullwidth is-radius">
                <i class="fas fa-sync is-padding-right-xsmall"></i>
                <span class="">Restaurer</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Option, DefaultValues } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
import DatePicker from '../utils/form/DatePicker.vue'
import moment from 'moment'

export default {
  name: 'LotOption',
  components: { DatePicker },
  mixins: [Option, DefaultValues],
  props: {
    firstOption: {
      type: [Object, Boolean]
    },
    waitingList: {
      type: Array
    },
    reservation: {
      type: [Object, Boolean]
    },
    program: {
      type: Object,
      required: false
    },
    canceledList: {
      type: Array
    }
  },
  data () {
    return {
      openedFirstComment: null,
      baseFirstComment: null,
      openedComment: null,
      baseLotComment: null,
      loadLotComment: false,
      textStyles: {
        fontSize: '1.4rem'
      },
      lastDate: null,
      lastPk: null,
      promoteur: null,
      reservationFirstOption: null,
      loadingOptionAction: false,
      displayWaitingList: true,
      multiselectStates: {},
      isReorganizingOptions: false,
      pendingRangChanges: {},
      hoveredRang: null,
      optionButtonList: [
        {
          action: (id, option) => {
            this.$store.commit('setQuickview', { mode: 'OPTION_UPDATE_DATE', params: { source: option } })
          },
          icon: 'fa-stopwatch',
          text: 'Prolonger option',
          needProfile: ['admin', 'manager'],
          display: (o) => {
            return this.canUpdateOption(o)
          }
        },
        {
          action: (id, option) => {
            this.$router.push({ name: 'PreReservation', params: { id: option.reservation.pk } })
          },
          // icon: 'fa-handshake',
          text: 'Demander le passage en pré-réservation',
          display: (o) => {
            if ((((this.isAdmin && !this.isPromoteur) || this.isManager) && o.account.pk === this.currentUser.account.pk) || (o.user.pk === this.currentUser.pk && !(this.isPromoteur && this.isAdmin))) {
              return o.status === 'approved' && o.reservation.status !== 'pending'
            }
          }
        },
        {
          action: (id, option) => {
            this.$router.push({ name: 'PreReservation', params: { id: option.reservation.pk } })
          },
          // icon: 'fa-handshake',
          text: 'Gérer la pré-réservation',
          display: (o) => {
            if (this.isPromoteur && this.isAdmin) {
              if ((o.user.pk === this.currentUser.pk) || (o.user.pk !== this.currentUser.pk && o.contact.account.pk === this.currentUser.account.pk)) {
                return o.status === 'approved'
              } else if (o.reservation) {
                return ('reservation' in o && o.reservation.status === 'pending') || o.account.pk === this.currentUser.account.pk
              }
            }
          }
        },
        {
          action: (id) => {
            this.confirmDelete().then(r => {
              if (r.value) {
                this.updateOption(id, { status: 'canceled' }, 'L\'option a été annulée.')
              }
            })
          },
          icon: 'fa-stop-circle',
          text: 'Stopper option',
          display: (o) => {
            return this.canUpgrade(o.status) && (this.isAdmin || o.user.pk === this.currentUser.pk || this.isInUserTeam(o.user.pk) || this.currentUser.active_all_contact)
          }
        },
        // {
        //   action: (id) => {
        //     this.$router.push({ name: 'AdvInfos', params: { id } })
        //   },
        //   // icon: 'fa-clipboard-list',
        //   text: 'Accéder à l\'adv',
        //   display: (o) => {
        //     return o.status === 'reserved' || o.status === 'sold' || o.status === 'pre_reserved'
        //   }
        // },
        // {
        //   action: (id) => {
        //     this.confirmDeleteReservation().then(r => {
        //       if (r.value) {
        //         this.updateOption(id, { status: 'canceled' }, 'La réservation a été annulée.')
        //       }
        //     })
        //   },
        //   icon: 'fa-stop-circle',
        //   text: 'Annuler ma demande de réservation',
        //   display: (o) => {
        //     return this.canUpgrade(o.status) && (this.isAdmin || o.user.pk === this.currentUser.pk || this.isInUserTeam(o.user.pk))
        //   }
        // },
        {
          action: (id) => {
            this.$emit('openModalTicket')
          },
          icon: 'fa-comment-alt-lines',
          text: 'Contacter responsable',
          display: (o) => {
            return !(this.isAdmin && this.isPromoteur)
          }
        },
        {
          action: (id, data) => {
            this.getContractUrl(data.reservation.pk)
          },
          icon: 'fa-file-alt',
          text: 'Visualiser dossier provisoire',
          display: (o) => {
            return this.isOptionReservationPending && !(this.isAdmin && this.isPromoteur) && this.reservationFirstOption && this.reservationFirstOption.is_complete && this.reservationFirstOption.reservation_contract
          }
        },
        {
          action: (id, data) => {
            this.$router.push({ name: 'AdvInfos', params: { id: id } })
          },
          icon: 'fa-file-alt',
          text: 'Accédez à l\'espace de gestion de la vente'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur']),
    ...mapState(['quickview', 'currentUser']),
    rangOptions () {
      // Génère les options de rang : firstOption (1) + waitingList.length
      const totalOptions = 1 + (this.waitingList ? this.waitingList.length : 0)
      return Array.from({ length: totalOptions }, (_, i) => `RANG ${i + 1}`)
    },
    reservationOkStatus () {
      let okStatus = ['pre_reserved', 'sold', 'reserved']
      return okStatus.includes(this.reservation.status)
    },
    isOptionReservationPending () {
      if (this.firstOption) {
        return this.firstOption.reservation.status === 'pending'
      } else {
        return false
      }
    },
    activeAllContact () {
      return this.currentUser.active_all_contact
    },
    hasPendingChanges () {
      return Object.keys(this.pendingRangChanges).length > 0
    },
    sortedWaitingList () {
      if (!this.waitingList || this.waitingList.length === 0) {
        return []
      }

      // S'il n'y a pas de changements en attente, retourner la liste originale
      if (Object.keys(this.pendingRangChanges).length === 0) {
        return this.waitingList
      }

      // Créer une liste complète incluant firstOption et waitingList
      const allOptions = []
      if (this.firstOption) {
        const firstPendingChange = this.pendingRangChanges[this.firstOption.pk]
        allOptions.push({
          ...this.firstOption,
          _displayRang: firstPendingChange ? firstPendingChange.newRang : 1,
          _isFirst: true
        })
      }

      this.waitingList.forEach((waiting, index) => {
        const originalRang = index + 2
        const pendingChange = this.pendingRangChanges[waiting.pk]
        allOptions.push({
          ...waiting,
          _displayRang: pendingChange ? pendingChange.newRang : originalRang,
          _isFirst: false
        })
      })

      // Trier par rang d'affichage
      const sorted = allOptions.sort((a, b) => a._displayRang - b._displayRang)

      // Retourner uniquement les options qui ne sont pas en position 1 (firstOption)
      return sorted.filter((_, index) => index !== 0)
    },
    sortedFirstOption () {
      if (!this.firstOption) {
        return null
      }

      if (Object.keys(this.pendingRangChanges).length === 0) {
        return this.firstOption
      }

      // Créer la liste complète avec tous les rangs temporaires
      const allOptions = []
      if (this.firstOption) {
        const firstPendingChange = this.pendingRangChanges[this.firstOption.pk]
        allOptions.push({
          ...this.firstOption,
          _displayRang: firstPendingChange ? firstPendingChange.newRang : 1,
          _isFirst: true
        })
      }

      this.waitingList.forEach((waiting, index) => {
        const originalRang = index + 2
        const pendingChange = this.pendingRangChanges[waiting.pk]
        allOptions.push({
          ...waiting,
          _displayRang: pendingChange ? pendingChange.newRang : originalRang,
          _isFirst: false
        })
      })

      // Trier et retourner la première option
      const sorted = allOptions.sort((a, b) => a._displayRang - b._displayRang)
      return sorted[0] || this.firstOption
    },
    canceledOffset () {
      const waitingListCount = this.waitingList.length || 0
      const hasFirstOption = this.firstOption != null

      return 1 + waitingListCount + (hasFirstOption ? 1 : 0)
    },
    displayCanceled () {
      if (!this.reservation) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'OPTION_UPDATE_DATE') {
        let params = {
          end_date: results.date
        }
        this.updateOption(results.option.pk, params, 'L\'option a été mise à jour.')
      }
    },
    async 'firstOption' (v) {
      if (v && v.reservation.status === 'pending' && !(this.isAdmin && this.isPromoteur)) {
        await this.getReservation()
        await this.getPromoteur()
      }
    }
  },
  async created () {
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside (event) {
      const clickedInsideMultiselect = event.target.closest('.multiselect-wrapper')
      if (!clickedInsideMultiselect) {
        Object.keys(this.multiselectStates).forEach(waitingId => {
          if (this.multiselectStates[waitingId].isOpen) {
            this.$set(this.multiselectStates, waitingId, {
              ...this.multiselectStates[waitingId],
              isOpen: false
            })
          }
        })
      }
    },
    async getReservation () {
      try {
        let { data } = await this.$api.getOne(this.$resources.RESERVATION, this.firstOption.reservation.pk)
        this.reservationFirstOption = Object.assign({}, data)
      } catch (err) {
        console.log(err)
      }
    },
    async getPromoteur () {
      try {
        let { data } = await this.$api.getOne(this.$resources.ACCOUNT, this.firstOption.promoteur.pk)
        this.promoteur = Object.assign({}, data)
      } catch (err) {
        console.log(err)
      }
    },
    async getContractUrl (pk) {
      const request = await this.$api.getReservationContract(pk)
      const win = window.open(request.data, '_blank')
      win.focus()
    },
    confirmDeleteReservation () {
      return this.$swal({
        title: 'Annulation',
        text: 'Êtes vous sûr de vouloir annuler cette réservation ?',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
          // cancelButton: 'button is-primary'
        }
      })
    },
    openWysiwygWaitingList (i) {
      if (this.openedComment === null && this.isPromoteur) {
        this.openedComment = i
        this.baseLotComment = this.waitingList[i].comment
      }
    },
    openWysiwygFirstOption () {
      if (this.openedFirstComment === null && this.isPromoteur) {
        this.openedFirstComment = true
        this.baseFirstComment = this.firstOption.comment
      }
    },
    async deleteWaitingComment (i) {
      let value = await this.$swal({
        title: 'Suppression commentaire',
        text: 'Confirmer la suppression du commentaire',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false
      else if (value.value && i >= 0) {
        this.waitingList[i].updated_on = this.moment().format()
        this.waitingList[i].comment = ''
        this.patchOptionMixins(this.waitingList[i])
      }
    },
    async deleteFirstComment () {
      let value = await this.$swal({
        title: 'Suppression commentaire',
        text: 'Confirmer la suppression du commentaire',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false
      else if (value.value) {
        this.firstOption.updated_on = this.moment().format()
        this.firstOption.comment = ''
        this.patchOptionMixins(this.firstOption)
      }
    },
    updatePreviousDate (newDate, option) {
      option.updated_on = this.moment().format()
      option.previous_sign_date = newDate
      if (newDate !== this.lastDate || option.pk !== this.lastPk) {
        this.patchOptionMixins(option)
      }
      this.lastDate = newDate
      this.lastPk = option.pk
    },
    toggleMultiselect (waitingId) {
      const currentState = this.getMultiselectState(waitingId)
      const newIsOpen = !currentState.isOpen

      if (newIsOpen) {
        Object.keys(this.multiselectStates).forEach(id => {
          if (id !== String(waitingId) && this.multiselectStates[id].isOpen) {
            this.$set(this.multiselectStates, id, {
              ...this.multiselectStates[id],
              isOpen: false
            })
          }
        })
      }

      this.$set(this.multiselectStates, waitingId, {
        selectedRang: currentState.selectedRang,
        isOpen: newIsOpen
      })
    },
    selectRang (waitingId, rang) {
      const newRangNumber = parseInt(rang.split(' ')[1])

      // Fermer le multiselect
      this.$set(this.multiselectStates, waitingId, {
        selectedRang: rang,
        isOpen: false
      })

      // Déterminer le rang ORIGINAL de cette option (dans firstOption/waitingList d'origine)
      let originalRangNumber
      if (this.firstOption && this.firstOption.pk === waitingId) {
        originalRangNumber = 1
      } else {
        const originalIndex = this.waitingList.findIndex(w => w.pk === waitingId)
        if (originalIndex === -1) return
        originalRangNumber = originalIndex + 2
      }

      // Calculer le rang ACTUEL de cette option (avec changements temporaires)
      const pendingChange = this.pendingRangChanges[waitingId]
      const currentRangNumber = pendingChange ? pendingChange.newRang : originalRangNumber

      // Si le nouveau rang est identique au rang actuel, ne rien faire
      if (newRangNumber === currentRangNumber) {
        return
      }

      // Construire la liste complète des options avec leurs rangs ACTUELS
      const allOptions = []

      if (this.firstOption) {
        const firstPending = this.pendingRangChanges[this.firstOption.pk]
        allOptions.push({
          pk: this.firstOption.pk,
          originalRang: 1,
          currentRang: firstPending ? firstPending.newRang : 1
        })
      }

      this.waitingList.forEach((w, index) => {
        const wOriginalRang = index + 2
        const wPending = this.pendingRangChanges[w.pk]
        allOptions.push({
          pk: w.pk,
          originalRang: wOriginalRang,
          currentRang: wPending ? wPending.newRang : wOriginalRang
        })
      })

      // Trouver l'option qui occupe actuellement le rang cible
      const targetOption = allOptions.find(opt => opt.pk !== waitingId && opt.currentRang === newRangNumber)

      if (targetOption) {
        // SWAP : l'option cible prend le rang actuel de l'option qu'on déplace
        this.$set(this.pendingRangChanges, targetOption.pk, {
          oldRang: targetOption.originalRang,
          newRang: currentRangNumber
        })

        // Mettre à jour son multiselect si elle n'est pas firstOption
        if (targetOption.pk !== this.firstOption.pk) {
          this.$set(this.multiselectStates, targetOption.pk, {
            selectedRang: `RANG ${currentRangNumber}`,
            isOpen: false
          })
        }
      }

      // Enregistrer le changement pour l'option actuelle
      this.$set(this.pendingRangChanges, waitingId, {
        oldRang: originalRangNumber,
        newRang: newRangNumber
      })

      // Si l'option revient à son rang d'origine, supprimer le changement
      if (newRangNumber === originalRangNumber) {
        this.$delete(this.pendingRangChanges, waitingId)
      }
    },
    cancelRangChanges () {
      this.pendingRangChanges = {}
      this.multiselectStates = {}
    },
    async applyRangChanges () {
      if (!this.hasPendingChanges) {
        return
      }

      this.isReorganizingOptions = true

      if (!this.program || !this.program.option_period) {
        this.$toasted.global.danger('Données du programme non disponibles')
        this.isReorganizingOptions = false
        return
      }

      // Construire le tableau complet des options avec leurs rangs FINAUX
      const allOptionsWithRangs = []

      if (this.firstOption) {
        const firstPending = this.pendingRangChanges[this.firstOption.pk]
        allOptionsWithRangs.push({
          option: this.firstOption,
          finalRang: firstPending ? firstPending.newRang : 1
        })
      }

      this.waitingList.forEach((waiting, index) => {
        const originalRang = index + 2
        const pending = this.pendingRangChanges[waiting.pk]
        allOptionsWithRangs.push({
          option: waiting,
          finalRang: pending ? pending.newRang : originalRang
        })
      })

      // Trier par rang final
      allOptionsWithRangs.sort((a, b) => a.finalRang - b.finalRang)

      // Extraire les options dans le bon ordre
      const reorderedOptions = allOptionsWithRangs.map(item => item.option)

      // Mettre à jour les dates et statuts
      let currentStartDate = moment()

      for (let index = 0; index < reorderedOptions.length; index++) {
        const option = reorderedOptions[index]
        const startDate = currentStartDate.format()
        const endDate = moment(currentStartDate).add(this.program.option_period, 'hours').format()

        option.status = (index === 0) ? 'approved' : 'waiting_list'
        option.start_date = startDate
        option.end_date = endDate
        option.updated_on = moment().format()

        currentStartDate = moment(endDate)
      }

      // Enregistrer les modifications en parallèle SANS passer par le store pour éviter les refreshes
      try {
        const updatePromises = reorderedOptions.map(async (option) => {
          await this.$api.patch(this.$resources.OPTION, option.pk, {
            status: option.status,
            start_date: option.start_date,
            end_date: option.end_date,
            updated_on: option.updated_on,
            comment: option.comment,
            previous_sign_date: option.previous_sign_date,
            created_on: option.created_on
          })
        })

        await Promise.all(updatePromises)

        // Réinitialiser les états
        this.multiselectStates = {}
        this.pendingRangChanges = {}

        this.$toasted.global.success('Options réorganisées avec succès')

        this.$emit('updateOption')
        this.isReorganizingOptions = false
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la réorganisation des options')
        this.isReorganizingOptions = false
      }
    },
    isPendingChange (waitingId) {
      return !!this.pendingRangChanges[waitingId]
    },
    getMultiselectState (waitingId) {
      // Toujours recalculer le rang basé sur les changements en attente
      let displayRang

      // Si l'option a un changement en attente, utiliser le nouveau rang
      if (this.pendingRangChanges[waitingId]) {
        displayRang = this.pendingRangChanges[waitingId].newRang
      } else {
        // Sinon, calculer le rang actuel
        const originalIndex = this.waitingList.findIndex(w => w.pk === waitingId)
        if (originalIndex !== -1) {
          displayRang = originalIndex + 2
        } else {
          displayRang = 1
        }
      }

      // Vérifier si un état de multiselect existe déjà
      if (this.multiselectStates[waitingId]) {
        return {
          isOpen: this.multiselectStates[waitingId].isOpen,
          selectedRang: `RANG ${displayRang}`
        }
      }

      return { isOpen: false, selectedRang: `RANG ${displayRang}` }
    },
    async restoreOptionsCanceled (optionPk) {
      let payload = {
        status: 'restored'
      }
      const test = 'Option restaurée'
      await this.updateOption(optionPk, payload, test)
    }
  }
}
</script>

<style scoped lang="scss">
.rond-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 0.75rem;
}

.rond {
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  position: relative;
  z-index: 2;
}

.trait-vertical {
  position: absolute;
  top: 10px;
  width: 1px;
  height: 40px;
  background-color: white;
  z-index: 1;
}

.no-style-button {
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* Custom Radio Button */
.radio-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.custom-radio {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-checkmark {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 2px solid #48c774;
  border-radius: 50%;
  background-color: white;
}

.custom-radio:checked ~ .radio-checkmark {
  background-color: white;
}

.custom-radio:checked ~ .radio-checkmark:after {
  content: "";
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #48c774;
}

/* Multiselect Styles */
.multiselect-wrapper {
  position: relative;
}

.multiselect-trigger {
  transition: background-color 0.2s;
}

.multiselect-trigger:hover {
  background-color: #f5f5f5;
}

.multiselect-option {
  transition: background-color 0.2s;
}

.multiselect-option:hover {
  background-color: #f5f5f5;
}

.multiselect-option.is-selected {
  background-color: #f0f9ff;
}

.fa-rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

.is-border--darken3 {
  border-color: #858585 !important;
}
</style>
